// src/components/common/DebugPanel.js
import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useAuth } from '../../auth/AuthContext';

const DebugPanel = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { user, activeEnvironment } = useAuth();
  
  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  // return (
  //   <div className="fixed bottom-0 right-0 bg-black bg-opacity-70 text-white p-3 m-3 rounded-lg text-xs max-w-sm z-50">
  //     <h3 className="font-bold">Auth Debug</h3>
  //     <div className="mt-1 space-y-1">
  //       <div>Path: {window.location.pathname}</div>
  //       <div>MSAL Auth: {isAuthenticated ? 'Yes' : 'No'}</div>
  //       <div>MSAL Accounts: {accounts.length}</div>
  //       <div>LocalStorage Auth: {localStorage.getItem('isAuthenticated') === 'true' ? 'Yes' : 'No'}</div>
  //       <div>User: {user ? `${user.name} (${user.email})` : 'None'}</div>
  //       <div>Environment: {activeEnvironment ? activeEnvironment.name : 'None'}</div>
  //     </div>
  //     <div className="mt-2 flex space-x-2">
  //       <button 
  //         onClick={() => {
  //           localStorage.setItem('isAuthenticated', 'true');
  //           window.location.href = '/environment-select';
  //         }}
  //         className="bg-blue-500 text-white px-2 py-1 rounded text-xs"
  //       >
  //         Force Auth
  //       </button>
  //       <button 
  //         onClick={() => {
  //           localStorage.removeItem('isAuthenticated');
  //           localStorage.removeItem('activeEnvironment');
  //           window.location.href = '/';
  //         }}
  //         className="bg-red-500 text-white px-2 py-1 rounded text-xs"
  //       >
  //         Clear Auth
  //       </button>
  //     </div>
  //   </div>
  // );
};

export default DebugPanel;